<template>
  <Modal class="modal-confirm-delete" id="modal-confirm-delete" #default="{ close }">
    <svg class="modal-confirm-delete__close" width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6.69727 7.19672L17.3039 17.8033" stroke="#CCD7E6" stroke-width="2" stroke-linecap="round"/>
      <path d="M17.3037 7.19672L6.69711 17.8033" stroke="#CCD7E6" stroke-width="2" stroke-linecap="round"/>
    </svg>
    <div class="modal-confirm-delete__content">
      <div class="modal-confirm-delete__label">Are you sure you want to delete all notifications?</div>
      <div class="actions">
        <button class="border large" @click="handle">
          <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 5.5H15" stroke="#003882" stroke-width="2" stroke-linecap="round"/>
            <path d="M3 5.5V12.5C3 14.1569 4.34315 15.5 6 15.5H10C11.6569 15.5 13 14.1569 13 12.5V5.5" stroke="#003882" stroke-width="2"/>
            <path d="M5 2.5H11" stroke="#003882" stroke-width="2" stroke-linecap="round"/>
          </svg>
          Delete
        </button>
        <button class="primary border large" @click="close">Cancel</button>
      </div>
    </div>
  </Modal>
</template>

<script>
import Modal from '@/components/modals/Modal.vue'
import { SvgIcon } from '@/components/ui'
import { mapActions, mapMutations } from 'vuex'

export default {
  name: 'ModalConfirmDelete',
  components: { Modal, SvgIcon },
  methods: {
    handle() {
      this.notificationsRemove();
      this.getNotifications();
      this.closeModal();
    },
    ...mapMutations(['closeModal']),
    ...mapActions('notifications', ['notificationsRemove', 'getNotifications']),
  }
}
</script>

<style lang="scss">
.modal-confirm-delete {
  flex-direction: column;

  &__content {
    display: flex;
    flex-direction: column;
    width: 302px;

    @include mobile {
      width: 100%;
    }
  }

  &__close {
    align-self: flex-end;
    margin-bottom: 24px;
    cursor: pointer;
  }

  &__label {
    margin-bottom: 40px;
    text-align: center;

    font-size: 15px;
    font-weight: 400;
    line-height: 23.63px;
    color: #352A58;
  }

  .content {
    padding: 35px;
    width: 500px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .actions {
    margin-top: 0;

    button {
      &:hover {
        svg {
          path {
            stroke: #CCD7E6;
          }
        }
      }
    }
  }
}
</style>
